import React, { Component } from 'react';

export class AdminVoteControll extends Component {
    constructor(props) {
        super(props);

        this.OpenShow = this.OpenShow.bind(this);
        this.CloseShow = this.CloseShow.bind(this);
        this.ClosePoll = this.ClosePoll.bind(this);
        this.ResetAll = this.ResetAll.bind(this);
        this.OpenPoll1 = this.OpenPoll1.bind(this);
        this.OpenPoll2 = this.OpenPoll2.bind(this);
        this.OpenPoll3 = this.OpenPoll3.bind(this);
    }

    APICall(method, api_path, JSON_body) {
        fetch(api_path, {
            method: method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON_body
        }).then(() => {
            this.props.rerenderParentCallback();
        })
    }

    OpenShow() { this.APICall('POST', 'api/StartTheShow', JSON.stringify({ "showStart": true })) }
    CloseShow() { this.APICall('POST', 'api/EndTheShow', null) }
    ClosePoll() { this.APICall('POST', 'api/ClosePoll', null) }
    ResetAll() { this.APICall('DELETE', 'api/ClearAll', null) }

    OpenPollofType(vote_type) {
        this.APICall('POST', 'api/OpenNewPoll', JSON.stringify({
            "voteOpen": true, "show_id": this.props.activeShowId, "pole_type": vote_type
        }))
    }
    OpenPoll1() { this.OpenPollofType(1) }
    OpenPoll2() { this.OpenPollofType(2) }
    OpenPoll3() { this.OpenPollofType(3) }


    render() {
        let OpenShowButton = <div><button className="btn btn-primary btn-admin btn-closePoll" onClick={this.OpenShow}>Open Show</button></div>
        let CloseShowButton = <div><button className="btn btn-primary btn-close-show" onClick={this.CloseShow}>Close Show</button></div>
        let OpenChoiceButton = (
            <div>
                <button className="btn btn-primary btn-admin btn-closePoll" onClick={this.OpenPoll1}>Open △ or ○ Choice</button>
                <button className="btn btn-primary btn-admin btn-closePoll" onClick={this.OpenPoll2}>Number Choice</button>
                <button className="btn btn-primary btn-admin btn-closePoll" onClick={this.OpenPoll3}>Quiet Choice</button>
            </div>
        )
        let CloseChoiceButton = <div><button className="btn btn-primary btn-admin btn-closePoll" onClick={this.ClosePoll}>Close Choice</button></div>
        let ResetAll = <button className="btn btn-primary btn-reset" onClick={this.ResetAll}>Total Reset</button>

        let buttons;
        if (this.props.activeShow === false) { buttons = <div>{OpenShowButton}</div> }
        else if (this.props.activePoll === false) { buttons = <div>{CloseShowButton}{OpenChoiceButton}</div> }
        else { buttons = <div>{CloseChoiceButton}</div> }

        return (
            <div>
                <div className="button-container">
                    {buttons}
                </div>
                <br />
                {ResetAll}
            </div>
        )
    }
}